import low from 'lowdb';
import LocalStorage from 'lowdb/adapters/LocalStorage';

const adapter = new LocalStorage('TIO');
const db = low(adapter);

db.defaults({ database: {
        contacts: [], // 最近联系人
        keyword: [], // 搜索记录
        history: [], // 浏览记录
        menuList: [], // 首页自定义tab
        user: {}, // 用户信息
        mailKeyword: []
    }
    })
    .write();

export default db;
